import React from 'react';
import {useSelector} from 'react-redux';

import useDeviceFirmwareUpdate from '../../hooks/useDeviceFirmwareUpdate';
import useReconnectDevice from '../../hooks/useReconnectDevice';
import useSyncDevice from '../../hooks/useSyncDevice';
import useUpdateDeviceStatus from '../../hooks/useUpdateDeviceStatus';
import {selectIsRetail} from '../../state/selectors/global';
import {selectIotDevicesDusnList} from '../../state/selectors/iotDevices';

const DeviceControllers = () => {
    const dusnList = useSelector(selectIotDevicesDusnList);
    const isRetail = useSelector(selectIsRetail);

    if (isRetail) return null;

    return dusnList.map((dusn) => <Controller key={dusn} dusn={dusn} />);
};

const Controller = ({dusn}) => {
    useSyncDevice(dusn);
    useReconnectDevice(dusn);
    useUpdateDeviceStatus(dusn);
    useDeviceFirmwareUpdate(dusn);
    return null;
};

export default DeviceControllers;
